export const SignInIcons = {
  signInMainImg: 'assets/img/icon/sign-in/sign-in-main-lock-open.png',
  closeButton: 'assets/img/icon/sign-in/close-btn.svg',
  picGoogle: 'assets/img/icon/google.svg',
  hidePassword: 'assets/img/icon/eye.png',
  showPassword: 'assets/img/icon/eye-show.png'
};
